import React, { Component } from 'react'
import uuid from 'uuid'

export class Row extends Component {
  constructor(props) {
    super(props)
    this.id = uuid.v4()
  }

  static defaultProps = {
    editable: {
      type: 'layout/row',
      name: '版块列表',
    },
    className: 'row',
    cols: 4, // 默认是4栏布局
  }

  render() {
    const props = this.props
    let classes = props.className
    classes = classes.split(" ").includes('row') ? classes : classes + ' row'
    return (
      <div className={ classes }>
        { props.children }
      </div>
    )
  }
}

export default Row



// WEBPACK FOOTER //
// ./app/javascript/app/site/components/layout/row/index.js